import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';

import EllipsisMenu       from 'app/components/common/ellipsis-menu';
import Icon               from 'app/components/common/icon';
import Link               from 'app/components/common/link';
import Meta               from 'app/components/common/meta';
import Modal              from 'app/components/common/modal';
import ModalNewWorkflow   from 'app/components/company-admin/grant-system/modal-new-workflow';
import ModalProgramAdmins from 'app/components/company-admin/grant-system/modal-program-admins';
import ModalProgramEdit   from 'app/components/company-admin/grant-system/modal-program-edit';
import WorkflowAssignees  from 'app/components/company-admin/grant-system/workflow-assignees';
import WorkflowKanban     from 'app/components/company-admin/grant-system/workflow-kanban';
import CadminLayout       from 'app/components/company-admin/layout/';
import ProgramCard        from 'app/components/grant-system/program-card';
import PageLoading        from 'app/components/layout/page-loading';
import {
  EmployeeRoles,
}                         from 'app/constants';
import GrantSysDuck       from 'app/ducks/company-admin/grant-system';
import helpers            from 'app/helpers/grant-system';
import format             from 'app/helpers/format';
import Ps                 from 'app/helpers/publish-statuses';
import history            from 'app/history';
import paths              from 'app/paths';
import prompts            from 'app/prompts';
import AuthSlx            from 'app/selectors/auth';
import CadminSlx          from 'app/selectors/company-admin/';
import EntitiesSlx        from 'app/selectors/entities';
import RoutingSlx         from 'app/selectors/routing';



class CadminPageGrantProgramShow extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      publishPending: false,
      archivePending: false,
      unarchivePending: false,
      shareFormPending: false,
      showNewWorkflowModal: false,
      showPublishModal: false,
      showSettingsModal: false,
      showAdminsModal: false,
    };

    this.onConfirmPublish = this.onConfirmPublish.bind(this);
    this.onClickPublish = this.onClickPublish.bind(this);
    this.onClosePublish = this.onClosePublish.bind(this);
    this.onClickArchive = this.onClickArchive.bind(this);
    this.onClickUnarchive = this.onClickUnarchive.bind(this);
    this.onClickAddWorkflow = this.onClickAddWorkflow.bind(this);
    this.onCloseAddWorkflow = this.onCloseAddWorkflow.bind(this);
    this.onClickSettings = this.onClickSettings.bind(this);
    this.onCloseSettings = this.onCloseSettings.bind(this);
    this.onClickAdmins = this.onClickAdmins.bind(this);
    this.onCloseAdmins = this.onCloseAdmins.bind(this);
  }

  componentDidMount() {

  }

  update(attrs) {
    const {program, update} = this.props;
    return update(program.company.id, program.id, attrs);
  }

  onClickPublish(event) {
    event.preventDefault();
    this.setState({showPublishModal: true});
  }
  onClosePublish() {
    this.setState({showPublishModal: false});
  }
  async onConfirmPublish() {
    this.setState({showPublishModal: false});
    // const didConfirm = await prompts.confirm({confirmBtnLabel: 'Publish Program', msg: 'Ready to publish this grant program?'});
    // if (!didConfirm) return;
    this.setState({publishPending: true});
    await this.update({publishStatus: Ps.ACTIVE});
    this.setState({publishPending: false});
  }
  async onClickArchive(event) {
    event.preventDefault();
    const didConfirm = await prompts.confirm({confirmBtnLabel: 'Archive Program', msg: 'Are you sure you want to archive this grant program?\nIt will still show up in the admin area and analytics, but will no longer be discoverable.'});
    if (!didConfirm) return;
    this.setState({archivePending: true});
    await this.update({publishStatus: Ps.ARCHIVED});
    this.setState({archivePending: false});
  }
  async onClickUnarchive(event) {
    event.preventDefault();
    const didConfirm = await prompts.confirm({confirmBtnLabel: 'Restore Program', msg: 'Are you sure you want to restore this grant program back to the published state?\nIt will become discoverable again.'});
    if (!didConfirm) return;
    this.setState({unarchivePending: true});
    await this.update({publishStatus: Ps.ACTIVE});
    this.setState({unarchivePending: false});
  }

  onClickSettings() {
    this.setState({showSettingsModal: true});
  }
  onCloseSettings() {
    this.setState({showSettingsModal: false});
  }

  onClickAdmins() {
    this.setState({showAdminsModal: true});
  }
  onCloseAdmins() {
    this.setState({showAdminsModal: false});
  }

  get currentTab() {
    if (this.props.currentTab) return this.props.currentTab;
    const isDraft = this.props.program?.publishStatus === Ps.DRAFT;
    return isDraft ? 'config' : 'apps';
  }
  set currentTab(tab) {
    const {company, program} = this.props;
    const query = {...this.props.query, tab};
    const path = paths.cadminGrantProgram(company.slug, program.id, query);
    history.push(path);
  }

  get role() {
    return this.props.currentUser?.employment?.employee?.role || undefined;
  }

  get isActive() {
    return this.props.program?.publishStatus === Ps.ACTIVE;
  }

  get isActiveish() {
    return Ps.isActiveish(this.props.program?.publishStatus);
  }

  get status() {
    const {program} = this.props;
    if (!program) return ['status', 'gray'];
    const ps = program.publishStatus;
    if (this.isActive) {
      const [label, color] = helpers.getProgramStatusDetails(program);
      return [label, color];
    }
    return [Ps.name(ps), Ps.color(ps)];
  }

  get forms() {
    const ids = this.props.program?.formIds || [];
    return ids.map(id => this.props.formMap[id]).filter(f => f);
  }

  get workflow() {
    const id = this.props.program.defaultGrantWorkflowId;
    return this.props.workflowMap[id] || null;
  }

  onClickTab(tab, event) {
    event.preventDefault();
    this.currentTab = tab;
  }

  async onClickShareForm(form, event) {
    event.preventDefault();
    const didConfirm = await prompts.confirm({confirmBtnLabel: 'Share this Form', msg: 'Are you sure you want to convert this form to a shared form?\nOther grant programs will be able to use it as well.\nChanges to the form will affect all grant programs using it.'});
    if (!didConfirm) return;
    this.setState({shareFormPending: true});
    // TODO: mark form as shared
    // await this.update({publishStatus: Ps.ARCHIVED});
    this.setState({shareFormPending: false});
  }

  onClickAddWorkflow() {
    this.setState({showNewWorkflowModal: true});
  }
  onCloseAddWorkflow() {
    this.setState({showNewWorkflowModal: false});
  }

  renderStatusPicker() {
    const {publishPending, archivePending, unarchivePending} = this.state;
    if (publishPending) return 'publishing...';
    if (archivePending) return 'archiving...';
    if (unarchivePending) return 'restoring...';

    const {company, program} = this.props;
    if (!program) return null;
    const ps = program.publishStatus;
    const [label, color] = this.status;
    const showPublish = (ps === Ps.DRAFT);
    const showArchive = (ps === Ps.ACTIVE);
    const showUnarchive = (ps === Ps.ARCHIVED);

    const target = (
      <div className="ca-ps-picker">
        <span>Status</span>
        <div className={`ca-ps-picker-tag ${color}`}>{label}</div>
        {(ps !== Ps.DELETED) && <Icon.Caret className="ca-ps-picker-caret" direction="down" />}
      </div>
    );
    return (
      <EllipsisMenu target={target}>
        {showPublish   && <a href="#" onClick={this.onClickPublish}>Publish</a>}
        {showUnarchive && <a href="#" onClick={this.onClickUnarchive}>Restore (un-archive)</a>}
        {showArchive   && <a href="#" onClick={this.onClickArchive}>Archive</a>}
      </EllipsisMenu>
    );
  }

  renderApps() {
    const {program, company, apps} = this.props;
    if (this.currentTab !== 'apps') return null;

    return (<>
      {!!this.workflow && (
        <div className="capg-prog-kanban-con">
          <WorkflowKanban company={company} workflow={this.workflow} minColWidth={220} />
        </div>
      )}
      {/* <div className="ca-box"> */}
      {/*   <div className="ca-box-header"> */}
      {/*     <h1 className="ca-box-header-title">Applications</h1> */}
      {/*   </div> */}
      {/*   <div className="ca-box-body"> */}
      {/*     <ScrollTable tableClassName="ca-box-table"> */}
      {/*       <thead> */}
      {/*         <tr> */}
      {/*           <th className="small">#</th> */}
      {/*           <th>Status</th> */}
      {/*           <th>Nonprofit</th> */}
      {/*           <th>Applicant</th> */}
      {/*           <th>Requested</th> */}
      {/*           <th>Submitted</th> */}
      {/*         </tr> */}
      {/*       </thead> */}
      {/*       <tbody> */}
      {/*         {apps.map((app) => { */}
      {/*           return ( */}
      {/*             <tr key={app.id}> */}
      {/*               <td className="small"> */}
      {/*                 <Link href={paths.cadminGrantApp(company.slug, app.id)} className="pink-hover">#{app.number}</Link> */}
      {/*               </td> */}
      {/*               <td>{app.status}</td> */}
      {/*               <td>{app.nonprofit && (<> */}
      {/*                 {app.nonprofit.name}<br /> */}
      {/*                 {app.nonprofit.ein || app.nonprofit.registeredNumber} */}
      {/*               </>)}</td> */}
      {/*               <td>{app.user && (<> */}
      {/*                 {`${app.user.firstName} ${app.user.lastName}`}<br /> */}
      {/*                 {app.user.email} */}
      {/*               </>)}</td> */}
      {/*               <td>{_.isFinite(app.amountRequested) ? format.usd(app.amountRequested) : ''}</td> */}
      {/*               <td>{!!app.submittedTs && <ClientTimestamp timestamp={app.submittedTs} />}</td> */}
      {/*             </tr> */}
      {/*           ); */}
      {/*         })} */}
      {/*       </tbody> */}
      {/*     </ScrollTable> */}
      {/*   </div> */}
      {/* </div> */}
    </>);
  }

  renderConfig() {
    const {program, company, cattrs, admins} = this.props;
    if (this.currentTab !== 'config') return null;
    const hasLandingPage = !!(program.landingText && program.imgPath);
    const hasForms = !!this.forms.length;
    const hasWorkflow = !!this.workflow;
    const pathEditPp  = paths.cadminGrantProgramEditLand(company.slug, program.id);
    const pathEditApp = paths.cadminGrantProgramEditApp(company.slug, program.id);

    return (<>
      <div className="ca-box">
        <div className="ca-box-header">
          <h1 className="ca-box-header-title">Application Flow</h1>
          <div className="ca-box-header-controls">
            {hasLandingPage && (
              <Link href={pathEditPp} className="btn small secondary blue">Edit Public Page</Link>
            )}
            {hasForms && (
              <Link href={pathEditApp} className="btn small secondary blue">Edit Application Flow</Link>
            )}
          </div>
        </div>
        <div className="ca-box-body">
          <div className="_flex _gap-36 _align-start">
            <div>
              <h3 className="capg-prog-box-header-2">Public Page</h3>
              {hasLandingPage ? (<>
                <ProgramCard program={program} />
              </>) : (<>
                <p className="_clr-mid _italic">Not yet configured.</p>
                <Link href={pathEditPp} className="btn blue">Setup Public Page</Link>
              </>)}
            </div>
            <div className="_flex-1">
              <h3 className="capg-prog-box-header-2">Applicant Forms</h3>
              {hasForms ? (<>
                <div className="capg-prog-forms">
                  {this.forms.map((form) => {
                    const isShared = !form.ownerId;
                    const fieldCount = form.formFields?.length || 0;
                    const canEdit = (() => {
                      if (!isShared) return true;
                      return this.role === EmployeeRoles.ADMIN;
                    })();
                    const pathEditForm = paths.cadminFormsEdit(company.slug, form.id);
                    return (
                      <div key={form.id} className="capg-prog-forms-form">
                        <Icon.TypeCursor className="capg-prog-forms-form-icon" />
                        <div className="capg-prog-forms-form-left">
                          <div className="capg-prog-forms-form-top">
                            <div className="capg-prog-forms-form-top-title">{form.title}</div>
                            {isShared && <div className="ca-form-card-shared-chip">Shared</div>}
                          </div>
                          <div className="capg-prog-forms-form-subtext">
                            {`${fieldCount} ${format.pluralize('question', fieldCount)}`}
                          </div>
                        </div>
                        <Link href={pathEditForm} disabled={!canEdit} className="btn small secondary ghost blue capg-prog-forms-form-edit">Edit Form</Link>
                      </div>
                    );
                  })}
                </div>
              </>) : (<>
                <p className="_clr-mid _italic">No forms added yet.</p>
                <Link href={pathEditApp} className="btn blue">Setup Application Flow</Link>
              </>)}
            </div>
          </div>
        </div>
      </div>

      <div className="ca-box">
        <div className="ca-box-header">
          <h1 className="ca-box-header-title">{hasWorkflow ? 'Workflow & Assignee Pool' : 'Workflow'}</h1>
          <div className="ca-box-header-controls">
            {hasWorkflow && (
              <Link href={paths.cadminGrantWorkflowsEdit(company.slug, this.workflow.id)} className="btn small secondary blue">Edit Workflow</Link>
            )}
          </div>
        </div>
        {hasWorkflow && <div className="ca-box-subheader">Each workflow task has its own pool of assignees.</div>}
        <div className="ca-box-body">
          {hasWorkflow ? (<>
            <div className="capg-prog-wfp-con">
              <WorkflowAssignees workflow={this.workflow} minColWidth={220} />
            </div>
          </>) : (<>
            <button className="btn blue" onClick={this.onClickAddWorkflow}>Setup Workflow</button>
          </>)}
        </div>
        <div className="ca-box-header">
          <h1 className="ca-box-header-title">Program Admins</h1>
          <div className="ca-box-header-controls">
            <button onClick={this.onClickAdmins} className="btn small secondary blue">Manage Admins</button>
          </div>
        </div>
        <div className="ca-box-body">
          <div className="capg-prog-admins">
            {admins?.length ? (<>
              {admins.map((emp) => {
                return (
                  <div key={emp.id} className="capg-prog-admins-admin">
                    <Icon.UserSingleNeutralCircle className="capg-prog-admins-admin-icon" />
                    <div className="capg-prog-admins-admin-text">
                      <div className="capg-prog-admins-admin-name _fw-bold">{`${emp.firstName} ${emp.lastName}`}</div>
                      <div className="capg-prog-admins-admin-subtext _clr-mid">{emp.email}</div>
                    </div>
                  </div>
                );
              })}
            </>) : (<>
              <p className="_clr-mid _italic">No admins added to this program yet.</p>
            </>)}
          </div>
        </div>
      </div>

      <div className="ca-box">
        <div className="ca-box-header">
          <h1 className="ca-box-header-title">Settings</h1>
          <div className="ca-box-header-controls">
            <button className="btn small secondary blue" onClick={this.onClickSettings}>Edit Settings</button>
          </div>
        </div>
        <div className="ca-box-body">
          <table className="attrs">
            <tbody>
              <tr>
                <th>Open Date</th>
                <td>{program.openDateStr ? moment.utc(program.openDateStr).format('MMMM D, YYYY') : <span className="_italic">not set</span>}</td>
              </tr>
              <tr>
                <th>Close Date</th>
                <td>{program.closeDateStr ? moment.utc(program.closeDateStr).format('MMMM D, YYYY') : <span className="_italic">not set</span>}</td>
              </tr>
              <tr>
                <th>Budget</th>
                <td>{_.isFinite(program.budget) ? format.usd(program.budget) : <span className="_italic">not set</span>}</td>
              </tr>
              {cattrs.map((cattr) => {
                const val = program.cattrs[cattr.id];
                const valLabel = val ? (cattr.options.find(o => o.id === val)?.label || null) : null;
                return (
                  <tr key={cattr.id}>
                    <th>{cattr.label}</th>
                    <td>{!!valLabel ? valLabel : <span className="_italic">not set</span>}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>);
  }

  renderPublishModal() {
    if (!this.state.showPublishModal) return null;
    const {program} = this.props;

    const hasLandingPage = !!(program.imgPath && program.landingText);
    const hasWorkflow = !!this.workflow;
    const hasForms = !!this.forms.length;

    const btnDisabled = (() => {
      if (!hasLandingPage) return true;
      if (!hasWorkflow) return true;
      if (!hasForms) return true;
      return false;
    })();

    return (
      <Modal className="bform" onClose={this.onClosePublish}>
        <h1 className="bform-h1">Ready to Publish?</h1>
        <label className="bform-h3">Checklist</label>
        <div className="capg-prog-launch-list">
          <div className="capg-prog-launch-list-item">
            <Icon.GoodOrBad isGood={hasLandingPage} />
            Landing Page
          </div>
          <div className="capg-prog-launch-list-item">
            <Icon.GoodOrBad isGood={hasForms} />
            Application Flow
          </div>
          <div className="capg-prog-launch-list-item">
            <Icon.GoodOrBad isGood={hasWorkflow} />
            Workflow
          </div>
        </div>
        <div className="bform-actions">
          <div className="bform-actions-right">
            <button className="btn blue" disabled={btnDisabled} onClick={this.onConfirmPublish}>Publish Program</button>
          </div>
        </div>
      </Modal>
    );
  }

  render() {
    const {company, program} = this.props;
    const {showNewWorkflowModal, showSettingsModal, showAdminsModal} = this.state;
    if (!company || !program) return <PageLoading />;
    const title = program?.title || 'Grant Program';
    const activeClass = tab => (tab === this.currentTab) ? 'active' : '';

    return (
      <CadminLayout company={company} activeItem="grant-programs" className="capg-prog">
        <Meta title={`${title} | Millie`} />

        <div className="ca-main-head">
          <Link className="ca-main-head-back" href={paths.cadminGrantPrograms(company.slug)}><Icon.Caret direction="left" /> Back to Programs</Link>
          <h1 className="ca-main-head-h1">{title}</h1>
          <div className="ca-main-head-actions">
            {this.renderStatusPicker()}
            <Link href={paths.grantProgram(program.id)} className="btn secondary blue">Public Page</Link>
            {/* <Link href={paths.grantProgramApply(program.id)} className="btn secondary blue">Application Form</Link> */}
          </div>
        </div>

        <div className="ca-main-tabs">
          <a href="#" className={`ca-main-tabs-tab ${activeClass('apps')}`} onClick={this.onClickTab.bind(this, 'apps')}>Applications</a>
          <a href="#" className={`ca-main-tabs-tab ${activeClass('config')}`} onClick={this.onClickTab.bind(this, 'config')}>Configuration</a>
        </div>

        {this.renderApps()}
        {this.renderConfig()}

        {showNewWorkflowModal && (
          <ModalNewWorkflow onClose={this.onCloseAddWorkflow} programId={program.id} />
        )}
        {showSettingsModal && (
          <ModalProgramEdit program={program} company={company} onClose={this.onCloseSettings} />
        )}
        {showAdminsModal && (
          <ModalProgramAdmins program={program} company={company} onClose={this.onCloseAdmins} />
        )}
        {this.renderPublishModal()}
      </CadminLayout>
    );
  }

}

const stateToProps = (state) => {
  const program = GrantSysDuck.Slx.pathProgram(state);
  return {
    currentUser: AuthSlx.currentUser(state),
    company: CadminSlx.company(state),
    program,
    admins: GrantSysDuck.Slx.programAdmins(state, program?.id),
    cattrs: GrantSysDuck.Slx.cattrs(state),
    formMap: EntitiesSlx.forms(state),
    workflowMap: EntitiesSlx.grantWorkflows(state),
    apps: GrantSysDuck.Slx.pathProgramApps(state),
    query: RoutingSlx.query(state),
    currentTab: RoutingSlx.query(state).tab || null,
  };
};
const dispatchToProps = (dispatch, ownProps) => ({
  update: (companyId, programId, attrs) => dispatch(GrantSysDuck.Ax.programsUpdate(companyId, programId, attrs)),
});

export default connect(stateToProps, dispatchToProps)(CadminPageGrantProgramShow);
